<template>
  <div class="uk-container">
    <div class="uk-text-center uk-margin">
      <router-link :to="{ name: `${textType}-create` }" class="uk-button uk-button-primary" data-cy="btn-create">Create {{ textType|capitalize }}</router-link>
    </div>

    <div class="uk-width-large uk-margin-auto uk-card uk-card-default" data-cy="user-list">
      <vue-good-table
        :columns="columns"
        :rows="list"
        :pagination-options="$globals.vgt.pagination"
        style-class="uk-table uk-table-middle uk-table-divider uk-table-hover uk-margin-remove datatable"
        @on-row-click="onRowClick"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentUserList',

  props: {
    type: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Name',
          field: 'name'
        },
        {
          label: 'Email',
          field: 'email',
          sortable: false
        }
      ]
    }
  },

  computed: {
    textType() {
      const types = {
        1: 'admin',
        2: 'operator'
      }
      return types[this.type]
    },

    list() {
      const source = this.$store.getters['users/getByType'](this.type)
      const rows = []

      source.forEach((item) => {
        rows.push({
          id: item.id,
          name: `${item.name.first} ${item.name.last}`,
          email: item.email
        })
      })

      return rows
    }
  },

  methods: {
    onRowClick(params) {
      this.$router.push({ name: `${this.textType}-manage`, params: { id: params.row.id } })
    }
  }
}
</script>
